const m = require('air-vue-model')()
m.url = 'product_ingredient_group_outlets'
m.name = 'productIngredientGroupOutlet'

m.filters = {
    product_ingredient_group: null
}

m.setPagination({
    page_size: 'all'
})

module.exports = m